import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'g10-ms-snackbar',
  templateUrl: './snackbar.html'
})
export class SnackbarComponent {
  constructor(
    // public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    // // @Inject(MAT_SNACK_BAR_DATA) public data: any
    // public data: any
  ) { }

}
